import { NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

export interface IRouteInfo {
  route: string;
  label: string;
}

export class RouteInfo implements IRouteInfo {
  route: string;
  label: string;
  constructor(route?: string, label?: string) {
    this.route = route || '';
    this.label = label || '';
  }
}

export interface IGrid {
  vwName: string;
  routeInfo: RouteInfo;
}

export class Grid implements IGrid {
  vwName: string;
  routeInfo: RouteInfo;
  constructor(vwName?: string, routeInfo?: RouteInfo) {
    this.vwName = vwName || '';
    this.routeInfo = routeInfo || new RouteInfo();
  }
}

export interface IForm {
  heading: string;
  routeInfo: RouteInfo;
}

export class Form implements IForm {
  heading: string;
  routeInfo: RouteInfo;
  constructor(heading?: string, routeInfo?: RouteInfo) {
    this.heading = heading || '';
    this.routeInfo = routeInfo || new RouteInfo();
  }
}

export const LargeDlgOptions: NgbModalOptions = {
  keyboard: false,
  size: "lg",
  backdrop: "static",
};

export const XLDlgOptions: NgbModalOptions = {
  keyboard: false,
  size: "xl",
  backdrop: "static",
};

export interface IMenu {
  grid: Grid;
  addForm: Form;
  editForm: Form;
}

export class Menu implements IMenu {
  id: string;
  api: string;
  grid: Grid;
  addForm: Form;
  editForm: Form;
  constructor(id: string, api: string, grid?: Grid, addForm?: Form, editForm?: Form) {
    this.id = id || "";
    this.api = api || '';
    this.grid = grid || new Grid();
    this.addForm = addForm || new Form();
    this.editForm = editForm || new Form();
  }
}

export const pBMenus: Array<Menu> = [];
//Dashboard
pBMenus.push(new Menu("Dashboard",
  '',
  new Grid('dashboard', new RouteInfo('dashboard', 'Dashboard'))//Grid
));
//Users
pBMenus.push(new Menu("Users",
  '',
  new Grid('vw_UserGrid', new RouteInfo('users', 'Users')),//Grid
  new Form('User', new RouteInfo('add-user', 'Add User')),//AddForm
  new Form('User', new RouteInfo('edit-user', 'Edit User'))//EditForm
));
//Profile
pBMenus.push(new Menu("Profile",
  'Account/',
  new Grid('', new RouteInfo('', 'Profile')),//Grid
  new Form('Profile', new RouteInfo('add-user', 'Add User')),//AddForm
  new Form('User', new RouteInfo('edit-user', 'Edit User'))//EditForm
));
//ChangePassword
pBMenus.push(new Menu("ChangePassword",
  'Account/ChangePassword/',
  new Grid('', new RouteInfo('', 'Change Password')),//Grid
  new Form('Blank', new RouteInfo('Blank', 'Blank')),//AddForm
  new Form('Blank', new RouteInfo('Blank', 'Blank'))//EditForm
));
//Tests
pBMenus.push(new Menu("Tests",
  'test/',
  new Grid('vw_TestGrid', new RouteInfo('tests', 'Tests')),//Grid
  new Form('Test', new RouteInfo('add-test', 'Add Test')),//AddForm
  new Form('Test', new RouteInfo('tab/edit-test', 'Edit Test'))//EditForm
));
//Tests
pBMenus.push(new Menu("TestsSub",
  'testSub/',
  new Grid('vw_TestSubGrid', new RouteInfo('tests/tab/testssub', 'Test Sub')),//Grid
  new Form('Test Sub', new RouteInfo('add-test-sub', 'Add Test Sub')),//AddForm
  new Form('Test Sub', new RouteInfo('edit-test-sub', 'Edit Test Sub'))//EditForm
));
//Tests Sub Tab One
pBMenus.push(new Menu("TestsSubTabOne",
  'testSub/',
  new Grid('vw_TestSubGrid', new RouteInfo('tests/tab/edit-test', 'Test Sub')),//Grid
  new Form('Test Sub', new RouteInfo('add-test-sub-tab-one', 'Add Test Sub')),//AddForm
  new Form('Test Sub', new RouteInfo('edit-test-sub-tab-one', 'Edit Test Sub'))//EditForm
));

//Tests
pBMenus.push(new Menu("TestsNote",
  'testNote/',
  new Grid('vw_TestNoteGrid', new RouteInfo('tests/tab/testnote', 'Test Note')),//Grid
  new Form('Test Note', new RouteInfo('add-test-note', 'Add Test Note')),//AddForm
  new Form('Test Note', new RouteInfo('edit-test-note', 'Edit Test Note'))//EditForm
));
//Templates
pBMenus.push(new Menu("Templates",
  'template/',
  new Grid('vw_TemplateGrid', new RouteInfo('templates', 'Templates')),//Grid
  new Form('Template', new RouteInfo('add-template', 'Add Template')),//AddForm
  new Form('Template', new RouteInfo('edit-template', 'Edit Template'))//EditForm
));
//Templates
pBMenus.push(new Menu("SafeIps",
  'SafeIps/',
  new Grid('vw_SafeIPsGrid', new RouteInfo('safe-ips', "Safe IP\'s")),//Grid
  new Form('SafeIps', new RouteInfo('add-safe-ip', 'Add Safe IP\'s')),//AddForm
  new Form('SafeIps', new RouteInfo('edit-safe-ip', 'Edit Safe IP\'s'))//EditForm
));
//Lookup Types
pBMenus.push(new Menu("LookupType",
  '',
  new Grid('vw_LookupTypeGrid', new RouteInfo('lookups', 'Lookups'))//Grid
));
//Lookup
pBMenus.push(new Menu("Lookups",
  'lookup/',
  new Grid('vw_LookupGrid', new RouteInfo('lookup-grid', 'Lookup')),//Grid
  new Form('Lookup', new RouteInfo('add-lookup', 'Add Lookup')),//AddForm
  new Form('Lookup', new RouteInfo('edit-lookup', 'Edit Lookup'))//EditForm
));
//Export Log
pBMenus.push(new Menu("ExportLog",
  '',
  new Grid('vw_ExportLogGrid', new RouteInfo('export-log', 'Export Log')),//Grid
));
//System Setting
pBMenus.push(new Menu("Options",
  'UserMenuOptionRole/', //api/UserMenuOptionRole
  new Grid('vw_UserMenuOptionRoleGrid', new RouteInfo('system-settings/options', 'Objects')),//Grid
  new Form('Options', new RouteInfo('add-options', 'Add Object')),//AddForm
  new Form('Options', new RouteInfo('edit-options', 'Edit Object'))//EditForm
));
pBMenus.push(new Menu("DashboardOptions",
  'UserDashboardOptionRole/', //api/UserDashboardOptionRole
  new Grid('vw_UserDashboardOptionRoleGrid', new RouteInfo('system-settings/dashboard', 'Dashboard Objects')),//Grid
  new Form('Dashboard', new RouteInfo('add-dashboard', 'Add Dashboard Object')),//AddForm
  new Form('Dashboard', new RouteInfo('edit-dashboard', 'Edit Dashboard Object'))//EditForm
));
pBMenus.push(new Menu("Groups",
  'UserGroup/', //api/UserGroup
  new Grid('vw_UserGroupGrid', new RouteInfo('system-settings/groups', 'Groups')),//Grid
  new Form('Groups', new RouteInfo('add-groups', 'Add Group')),//AddForm
  new Form('Groups', new RouteInfo('edit-groups', 'Edit Group'))//EditForm
));
//Login Analysis
pBMenus.push(new Menu("LoginAnalysis",
  '',
  new Grid('vw_AspNetUserLogsGrid', new RouteInfo('login-analysis', 'Login Analysis')),//Grid
  new Form('loginAnalysis', new RouteInfo('', 'Add Options')),//AddForm
  new Form('loginAnalysis', new RouteInfo('login-analysis-detail', 'Login Analysis Detail'))//EditForm
));
//Email
pBMenus.push(new Menu("Email",
  'Email/',
  new Grid('vw_EmailGrid', new RouteInfo('email', 'Email')),//Grid
  new Form('Email', new RouteInfo('add-email', 'Add Email')),//AddForm
  new Form('Email', new RouteInfo('edit-email', 'Edit Email'))//EditForm
));
// Email Template
pBMenus.push(new Menu("EmailTemplate",
  'EmailTemplate/',
  new Grid('vw_EmailTemplateGrid', new RouteInfo('email-template', 'Email Template')),//Grid
  new Form('Email Template', new RouteInfo('add-email-template', 'Add Email Template')),//AddForm
  new Form('Email Template', new RouteInfo('edit-email-template', 'Edit Email Template'))//EditForm
));
pBMenus.push(new Menu("Agreement",
  'agreement/',
  new Grid('vw_AgreementGrid', new RouteInfo('agreement', 'Agreements')),//Grid
  new Form('Agreement', new RouteInfo('add-agreement', 'Add Agreement')),//AddForm
  new Form('Agreement', new RouteInfo('edit-agreement', 'Edit Agreement'))//EditForm
));
pBMenus.push(new Menu("AgreementUser",
  'agreement/',
  new Grid('vw_AgreementUserSubGrid', new RouteInfo('agreement', 'Agreement User')),//Grid
));
pBMenus.push(new Menu("AgreementVersion",
  'agreement/',
  new Grid('vw_AgreementVersionSubGrid', new RouteInfo('agreement/edit-agreement', 'Version History')),//Grid
  new Form('Version History', new RouteInfo('add-agreement-version', 'Add Version History')),//AddForm
  new Form('Version History', new RouteInfo('edit-agreement-version', 'Edit Version History'))//EditForm
));
pBMenus.push(new Menu("SystemAlerts",
  'SystemAlertsForm/',
  new Grid('vw_SystemAlertGrid', new RouteInfo('system-alerts', 'System Alerts')),//Grid
  new Form('System Alerts', new RouteInfo('add-system-alerts', 'Add System Alerts')),//AddForm
  new Form('System Alerts', new RouteInfo('edit-system-alerts', 'Edit System Alerts'))//EditForm
));
pBMenus.push(new Menu("SystemAdministration",
  'ApplicationInformation/',
  new Grid('vw_SystemAlertGrid', new RouteInfo('system-administration', 'System Administration')),//Grid
  new Form('System Administration', new RouteInfo('add-system-administration', 'Add System Administration')),//AddForm
  new Form('System Administration', new RouteInfo('system-administration', 'System Administration'))//EditForm
));
pBMenus.push(new Menu("TermsAndConditions",
  'userAgreement/',
  new Grid('vw_UserAgreementForm', new RouteInfo('dashboard-tc', 'Terms & Conditions')),//Grid
  new Form('UserAgreement', new RouteInfo('add-dashboard-tc', 'Add Terms & Conditions')),//AddForm
  new Form('UserAgreement', new RouteInfo('edit-dashboard-tc', 'Edit Terms & Conditions'))//EditForm
));
//Invalid Email Log
let invalidEmailLog = new Menu("InvalidEmailLog",
  "vw_InvalidEmailLogGrid/",
  new Grid("vw_InvalidEmailLogGrid", new RouteInfo("invalid-email-log", "Invalid Email Log")), //Grid
  new Form("", new RouteInfo("", "")), //AddForm
  new Form("", new RouteInfo("", "")) //EditForm
);
pBMenus.push(invalidEmailLog);
//Brokers
pBMenus.push(new Menu("Brokers",
  'Broker/',
  new Grid('vw_BrokerGrid', new RouteInfo('brokers', 'Broker')),//Grid
  new Form('Brokers', new RouteInfo('add-broker', 'Add Broker')),//AddForm
  new Form('Brokers', new RouteInfo('edit-broker', 'Edit Broker'))//EditForm
));
pBMenus.push(new Menu("BrokerContact",
  'BrokerContact/',
  new Grid('vw_BrokerContactSubGrid', new RouteInfo('brokerContact', 'Broker Contacts')),//Grid
  new Form('Broker Contacts', new RouteInfo('add-broker-contact', 'Add Broker Contact')),//AddForm
  new Form('Broker Contacts', new RouteInfo('edit-broker-contact', 'Edit Broker Contact'))//EditForm
));
//Underwriter
pBMenus.push(new Menu("Underwriters",
  'Underwriter/',
  new Grid('vw_UnderwriterGrid', new RouteInfo('underwriter', 'Underwriter')),//Grid
  new Form('Underwriter', new RouteInfo('add-underwriter', 'Add Underwriter')),//AddForm
  new Form('Underwriter', new RouteInfo('edit-underwriter', 'Edit Underwriter'))//EditForm
));
pBMenus.push(new Menu("UnderwriterContact",
  'UnderwriterContact/',
  new Grid('vw_UnderwriterContactSubGrid', new RouteInfo('underwriterContact', 'Underwriter Contacts')),//Grid
  new Form('Underwriter Contacts', new RouteInfo('add-underwriter-contact', 'Add Underwriter Contact')),//AddForm
  new Form('Underwriter Contacts', new RouteInfo('edit-underwriter-contact', 'Edit Underwriter Contact'))//EditForm
));
//Clients
pBMenus.push(new Menu("Clients",
  'Client/',
  new Grid('vw_ClientGrid', new RouteInfo('clients', 'Client')),//Grid
  new Form('Clients', new RouteInfo('add-client', 'Add Client')),//AddForm
  new Form('Clients', new RouteInfo('edit-client', 'Edit Client'))//EditForm
));
pBMenus.push(new Menu("ClientContact",
  'ClientContact/',
  new Grid('vw_ClientContactSubGrid', new RouteInfo('clientContact', 'Clients Contacts')),//Grid
  new Form('Client Contacts', new RouteInfo('add-client-contact', 'Add Client Contact')),//AddForm
  new Form('Client Contacts', new RouteInfo('edit-client-contact', 'Edit Client Contact'))//EditForm
));
pBMenus.push(new Menu("ClientCommission",
  'ClientCommission/',
  new Grid('vw_ClientCommissionSubGrid', new RouteInfo('clientCommission', 'Client Commissions')),//Grid
  new Form('Client Commissions', new RouteInfo('add-client-commission', 'Add Client Commission')),//AddForm
  new Form('Client Commissions', new RouteInfo('edit-client-commission', 'Edit Client Commission'))//EditForm
));
pBMenus.push(new Menu("ClientBank",
  'ClientBank/',
  new Grid('vw_ClientBankSubGrid', new RouteInfo('clientBank', 'Clients Bank')),//Grid
  new Form('Client Bank', new RouteInfo('add-client-bank', 'Add Client Bank')),//AddForm
  new Form('Client Bank', new RouteInfo('edit-client-bank', 'Edit Client Bank'))//EditForm
));
//Case
pBMenus.push(new Menu("Cases",
  'Case/',
  new Grid('vw_CaseGrid', new RouteInfo('case/list', 'Case List')),//Grid
  new Form('Case', new RouteInfo('add-case', 'Add Case')),//AddForm
  new Form('Case', new RouteInfo('edit-case', 'Edit Case'))//EditForm
));

pBMenus.push(new Menu("CasesByUnderwriter",
  'Case/',
  new Grid('vw_CaseUnderwriterGrid', new RouteInfo('case/underwriter', 'Case by Underwriter')),//Grid
  new Form('Case', new RouteInfo('add-case', 'Add Case')),//AddForm
  new Form('Case', new RouteInfo('edit-case', 'Edit Case'))//EditForm
));
//case > sequence
pBMenus.push(new Menu("Sequence",
  'CaseSequence/',
  new Grid('vw_CaseSequenceSubGrid', new RouteInfo('sequence', 'Sequence')),//Grid
  new Form('Case Sequence', new RouteInfo('add-case-sequence', 'Add Case Sequence')),//AddForm
  new Form('Case Sequence', new RouteInfo('edit-case-sequence', 'Edit Case Sequence'))//EditForm
));
//case > breakdown
pBMenus.push(new Menu("Breakdown",
  'CaseBreakdown/',
  new Grid('vw_CaseBreakdownSubGrid', new RouteInfo('breakdown', 'Breakdown')),//Grid
  new Form('Case Breakdown', new RouteInfo('add-case-breakdown', 'Add Case Breakdown')),//AddForm
  new Form('Case Breakdown', new RouteInfo('edit-case-breakdown', 'Edit Case Breakdown'))//EditForm
));
//invoice
pBMenus.push(new Menu("Invoices",
  'Invoice/',
  new Grid('vw_InvoiceGrid', new RouteInfo('invoice', 'Invoice')),//Grid
  new Form('Invoice', new RouteInfo('add-invoice', 'Add Invoice')),//AddForm
  new Form('Invoice', new RouteInfo('edit-invoice', 'Edit Invoice'))//EditForm
));
pBMenus.push(new Menu("InvoiceBreakdown",
  'InvoiceBreakdown/',
  new Grid('vw_InvoiceBreakdownSubGrid', new RouteInfo('invoiceBreakdown', 'InvoiceBreakdown')),//Grid
  new Form('Invoice', new RouteInfo('add-invoice-breakdown', 'Add Invoice Breakdown')),//AddForm
  new Form('Invoice', new RouteInfo('edit-invoice-breakdown', 'Edit Invoice Breakdown'))//EditForm
));
pBMenus.push(new Menu("Invoiceposts",
  'Invoicepost/',
  new Grid('vw_InvoicePostGrid', new RouteInfo('invoice-post', 'All Invoice Post')),//Grid
  new Form('Invoice-post', new RouteInfo('add-invoice-post', 'Add Invoice Post')),//AddForm
  new Form('Invoice-post', new RouteInfo('edit-invoice-post', 'Edit Invoice Post'))//EditForm

));

pBMenus.push(new Menu("InvoicepostProcessed",
  '',
  new Grid('vw_InvoicePostProcessedGrid', new RouteInfo('invoice-post/processed', 'Processed')),//Grid
  new Form('Invoice-post', new RouteInfo('add-invoice-post', 'Add Invoice Post')),//AddForm
  new Form('Invoice-post', new RouteInfo('edit-invoice-post', 'Edit Invoice Post'))//EditForm
));

pBMenus.push(new Menu(
  "InvoicepostsUnprocessed", 
  '',
  new Grid('vw_InvoicePostUnprocessedGrid', new RouteInfo('invoice-post/unprocessed', 'Unprocessed')), 
  new Form('Invoice-post', new RouteInfo('add-invoice-post', 'Add Invoice Post')),//AddForm
  new Form('Invoice-post', new RouteInfo('edit-invoice-post', 'Edit Invoice Post'))//EditForm
));


pBMenus.push(new Menu("InvoiceBreakdownTempSub",
  'InvoiceBreakdownTempSub/',
  new Grid('vw_InvoiceBreakdownTempSubGrid', new RouteInfo('invoiceBreakdown', 'InvoiceBreakdown')),//Grid
  new Form('', new RouteInfo('', '')),//AddForm
  new Form('', new RouteInfo('', ''))//EditForm
));
pBMenus.push(new Menu("BankAccounts",
  'BankAccount/',
  new Grid('vw_BankAccountGrid', new RouteInfo('bank-accounts', 'Bank Accounts')),//Grid
  new Form('Bank-Accounts', new RouteInfo('add-bank-accounts', 'Add Bank Account')),//AddForm
  new Form('Bank-Accounts', new RouteInfo('edit-bank-accounts', 'Edit Bank Account'))//EditForm
));
pBMenus.push(new Menu("BankAccountImport",
  'BankAccountImport/',
  new Grid('vw_IbaBankImportGrid', new RouteInfo('bank-import-grid', 'IBA Bank Imports')),//Grid
  new Form('IBA-Bank-Import', new RouteInfo('bank-import', 'IBA Bank Import')),//AddForm
  new Form('', new RouteInfo('', ''))//EditForm
));
pBMenus.push(new Menu("BankReconciliation",
  "BankReconciliation/",
  new Grid("vw_BankReconciliationBankAccountGrid", new RouteInfo("bank-reconciliation", "Bank Reconciliation")), //Grid
  new Form("Bank-Reconciliation", new RouteInfo("edit-bank-reconciliation", "Edit Bank Reconciliation")), //EditForm
  new Form("", new RouteInfo("", "")) //AddForm
)
);



pBMenus.push(new Menu("Reconcile",
  "Reconcile/",
  new Grid("vw_BankReconciliationReconcileGrid", new RouteInfo("reconcile", "Reconcile")), //Grid
  new Form('Reconcile', new RouteInfo('edit-reconcile', 'Edit Reconcile'))//EditForm
)
);
pBMenus.push(new Menu("ReconciliationBankTransaction",
  "ReconciliationBankTransaction/",
  new Grid("vw_BankReconciliationBankTransactionGrid", new RouteInfo("", "Reconciliation Bank Transaction")) //Grid
)
);
pBMenus.push(new Menu("ReconciliationSearch",
  "ReconciliationSearch/",
  new Grid("vw_BankReconciliationSearchGrid", new RouteInfo("", "Reconciliation Search")) //Grid
)
);
pBMenus.push(new Menu("Comments",
  'InvoiceBreakdownComment/',
  new Grid('vw_InvoiceBreakdownCommentSubGrid', new RouteInfo('comments', 'Comments')),//Grid
  new Form('Comments', new RouteInfo('add-comment', 'Add Comment')),//AddForm
  new Form('Comments', new RouteInfo('edit-comment', 'Edit Comment'))//EditForm
));

// Unallocated Cash
pBMenus.push(new Menu("UnallocatedCashBankAccount",
  "",
  new Grid("vw_UnallocatedCashBankAccountGrid", new RouteInfo("unallocated-cash-bank-account", "Unallocated Cash Bank Account")), //Grid

));
pBMenus.push(new Menu("UnallocatedCash",
  "vw_UnallocatedCashTransactionHeader/",
  new Grid("vw_UnallocatedCashGrid", new RouteInfo("unallocated-cash", "Unallocated Cash")), //Grid
  new Form('Unallocated Cash', new RouteInfo('edit-unallocated-cash', 'Unallocated Cash Transaction'))//EditForm
)
);

// Outstanding Balance
pBMenus.push(new Menu("OutstandingBalance",
  "",
  new Grid("vw_OutstandingBalanceGrid", new RouteInfo("outstanding-balance", "Outstanding Balances")), //Grid

));

// holding account
pBMenus.push(new Menu("HoldingAccountBankAcount",
  "",
  new Grid("vw_HoldingAccountBankAccountGrid", new RouteInfo("holding-account-bank-account", "Holding Account Bank Acount")), //Grid
)
);

pBMenus.push(new Menu("HoldingAccount",
  "vw_HoldingAccountTransactionHeader/",
  new Grid("vw_HoldingAccountGrid", new RouteInfo("holding-account", "Holding Account")), //Grid
  new Form('Holding Account', new RouteInfo('edit-holding-account', 'Holding Account Transaction'))//EditForm
)
);

// client account

pBMenus.push(new Menu("ClientAccount",
  "",
  new Grid("vw_ClientAccountGrid", new RouteInfo("client-account", "Client Account")), //Grid
)
);
pBMenus.push(new Menu("ClientAccountCurrency",
  "",
  new Grid("vw_ClientAccountCurrencyGrid", new RouteInfo("client-account-currency", "Client Account Currency")), //Grid
)
);

pBMenus.push(new Menu("ClientPayment",
  "",
  new Grid("vw_ClientPaymentGrid", new RouteInfo("client-account", "Client Payment")), //Grid
)
);
pBMenus.push(new Menu("ClientPaymentCurrency",
  "",
  new Grid("vw_ClientPaymentCurrencyGrid", new RouteInfo("client-account-currency", "Client Payment Currency")), //Grid
)
);
pBMenus.push(new Menu("ClientAccountBreakdown",
  "vw_ClientAccountTransactionHeader/",
  new Grid("vw_ClientAccountBreakdownGrid", new RouteInfo("client-account-breakdown", "Client Account Breakdown")), //Grid
  new Form('Client Account Breakdown', new RouteInfo('client-account-transaction', 'Client Account Transaction'))//EditForm
)
);
pBMenus.push(new Menu("ClientPaymentBreakdown",
  "vw_ClientAccountTransactionHeader/",
  new Grid("vw_ClientPaymentBreakdownGrid", new RouteInfo("client-account-breakdown", "Client Payment Breakdown")), //Grid
  new Form('Client Payment Breakdown', new RouteInfo('client-account-transaction', 'Client Payment Transaction'))//EditForm
)
);
pBMenus.push(new Menu("Payments",
  '',
  new Grid('vw_InvoiceBreakdownPaymentSubGrid', new RouteInfo('payments', 'Payments')),//Grid
  new Form('', new RouteInfo('', '')),//AddForm
  new Form('', new RouteInfo('', ''))//EditForm
));


//GroupInvoices
pBMenus.push(new Menu("GroupInvoices",
  '/',
  new Grid('InvoiceGroupSelect', new RouteInfo('group-invoices/group-invoices', 'Update Invoices')),
));

//BulkUpdateInvoices
pBMenus.push(new Menu("BulkUpdateInvoices",
  '/',
  new Grid('vw_InvoiceBulkUpdateGrid', new RouteInfo('group-invoices/bulk-update', 'Bulk Update')),
));

//InvoiceGroups
pBMenus.push(new Menu("InvoiceGroups",
  'vw_InvoiceGroupGrouped/',
  new Grid('vw_InvoiceGroupGrid', new RouteInfo('group-invoices/invoice-groups', 'Invoice Groups')),
  new Form('Grouped Invoices', new RouteInfo('group-invoices/invoice-groups/edit-group-invoice-form', 'Edit Invoice Groups'))
));


export enum InfoMessage {
  SaveMessage = "Data successfully saved",
  DeleteMessage = "Data has been deleted successfully",
  ErrorMessage = "Something went wrong",
  SelectMessage = "Please select a record to proceed",
  CopyMessage = "Record has been copied successfully"
}
